const AOS = require("aos");
const $ = require("jquery");
// const _ = require('lodash');

require("@popperjs/core");
require("bootstrap");
require("slick-carousel");

window.jQuery = $;

$(function () {
  loadAOS();
  initSliders();
  initGoogleMapping();
  containerFix();
  submenuOffset();
  heroOffset();
  heroUSP();
  addQuantityButtons();
  cartTitle();
  moveOrderTitle();
  toggleAccordionItems();
  singleQty();
  headerFix();
  centerSlider(".brands-slider");
  centerSlider(".product-cat-slider");
  filterToggle();

  function toggleVAT() {
    const exVatEls = document.querySelectorAll('.ex-vat');
    const incVatEls = document.querySelectorAll('.inc-vat');

    exVatEls.forEach(el => el.classList.toggle('d-none'));
    incVatEls.forEach(el => el.classList.toggle('d-none'));
  }

  // Runs server image replace function based on domain
  if (window.location.hostname === 'tfpumps.test' || window.location.hostname === 'localhost') {
    imageReplace();
  }

  function headerFix() {
    var windowWidth = $(window).width();
    var firstSection = $('section').first();
    let headerHeight = 0;

    if (windowWidth > 992) {
      headerHeight = 160;
    } else if (windowWidth > 405) {
      headerHeight = 140;
    } else if (windowWidth > 376) {
      headerHeight = 120;
    } else {
      headerHeight = 102;
    }

    $(firstSection).css("margin-top", `${headerHeight}px`);
  }

  function moveOrderTitle() {
    // Find the #order_review_heading and #order_review elements
    var orderReviewHeading = $("#order_review_heading");
    var orderReview = $("#order_review");

    // Check if both elements exist
    if (orderReviewHeading.length > 0 && orderReview.length > 0) {
      // Move #order_review_heading inside #order_review
      orderReview.prepend(orderReviewHeading);
    }
  }

  // Re-run the script after each cart update
  $(document.body).on("updated_cart_totals", function () {
    addQuantityButtons();
    cartTitle();

    setTimeout(function () {
      updateActionButtonState();
    }, 500);
  });

  if ($("body").hasClass("woocommerce-cart")) {
    // Call the function to update cart count initially
    updateCartCount();

    // Optionally, you can set up an interval to periodically update the cart count
    // For example, every 5 seconds
    setInterval(updateCartCount, 5000);
  }

  // handler for the resize window event
  $(window).on("resize", function () {
    containerFix();
    heroUSP();
    toggleAccordionItems();
    headerFix();
    centerSlider(".brands-slider");
    centerSlider(".product-cat-slider");
    filterToggle();
  });

  // handler for the scroll window event
  $(window).on("scroll", function () {
    checkWindowScroll();
    uncoverElements();
  });

  setTimeout(function () {
    updateActionButtonState();
  }, 500);

  // Adds height to the .usp-fix if USP Review section is second in the output

  function heroUSP() {
    let windowWidth = $(window).width();
    if (windowWidth >= 992) {
      if ($("#uspReviews-2").length) {
        $(".hero .usp-fix").css("height", "82px");
        $(".hero .hero-overlay").css("height", "calc(100% + 82px)");
      }
    } else {
      $(".hero .hero-overlay").removeAttr("style");
      $(".hero .usp-fix").removeAttr("style");
    }
  }

  // Smooth scroll.
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on("click", function (event) {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);

        if ($("section.timeline").length > 0) {
          var offset = $("header").outerHeight() + 74;
        } else {
          var offset = $("header").outerHeight();
        }

        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top - offset,
            },
            1000
          );
        }
      }
    });

  // Burger click
  $("#burger").click(function () {
    open = !open;
    toggleMenu(open);
    submenuOffset();
  });

  // Active class.
  $("header .nav [href]").each(function () {
    if (this.href == window.location.href) {
      $(this).addClass("active");
    }
  });

  // Submenu.
  $(".submenu-toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent-item").toggleClass("open");
    var submenu = $(this).next(".submenu");
    submenu.addClass("open");
  });

  $(".back-btn").on("click", function () {
    var currentItem = $(this);
    var submenu = currentItem.closest(".submenu");
    submenu.removeClass("open");
  });

  // Compatibility Calculator AJAX
  cardsSearch("all");

  var timeout;

  $(".search-container input").on("input change", function () {
    var input = $(this);
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      var searchEntered = input.val();
      cardsSearch(searchEntered);
    }, 500);
  });

  function cardsSearch(search_query) {
    $.ajax({
      url: "/wp-content/themes/compatibility-calculator.php",
      type: "POST",
      data: {
        search_query: search_query,
      },
      success: function (response) {
        $(".chemical-result").html(response);
      },
      error: function (xhr, status, error) {
        console.error(error);
      },
    });
  }

  // Plus Minus Functionality JS
  function singleQty() {
    $(".single-product .quantity").each(function () {
      var $quantitySection = $(this);
      var $quantityInput = $quantitySection.find("input.qty");

      // Append custom buttons
      $quantitySection.append('<span class="minus"></span>');
      $quantitySection.append('<span class="plus"></span>');

      // Custom quantity input field increment and decrement
      $quantitySection.on("click", ".plus, .minus", function () {
        var currentQuantity = parseInt($quantityInput.val());

        if ($(this).hasClass("plus")) {
          $quantityInput.val(currentQuantity + 1);
        } else if (currentQuantity > 1) {
          $quantityInput.val(currentQuantity - 1);
        }
      });
    });
  }

  // Add current URL to Ninja Form

  $(".icon-link").on("click", function () {
    // Get the closest .resource-doc-url element and its src attribute value
    var dataUrl = $(this).data("url");
    var target = $(this).attr("data-bs-target");

    // Assign the src value to a variable and set it as the value of .product-url input
    $(target + " .resourcesForm .product-url")
      .attr("value", dataUrl)
      .trigger("change");
  });

  // Update cart count AJAX
  function updateCartCount() {
    // Make an AJAX request to get the cart count
    $.ajax({
      url: wc_cart_params.ajax_url,
      type: "GET",
      data: {
        action: "get_cart_count",
      },
      success: function (response) {
        // Update the cart count in the specified div
        $(".cart-number").text(response);
      },
      error: function (error) {
        console.error("Error fetching cart count:", error);
      },
    });
  }

  // Updating basket text
  function cartTitle() {
    // Select the h2 element within the .cart_totals class
    var cartTotalsHeading = $(".cart_totals h2");

    // Check if the element exists
    if (cartTotalsHeading.length > 0) {
      // Change the text content
      cartTotalsHeading.text("Totals");
    }
  }

  // WooCommerce Basket QTY
  function addQuantityButtons() {
    $(".woocommerce-cart .woocommerce table.shop_table.cart")
      .find("tr.cart_item")
      .each(function () {
        // Find the quantity input field in the current basket item
        var qtyInput = $(this).find("input.qty");

        // Add plus and minus buttons if not already added
        if (!$(this).find(".minus").length && !$(this).find(".plus").length) {
          qtyInput.before(
            '<button class="minus"><i class="fa-regular fa-minus"></i></button>'
          );
          qtyInput.after(
            '<button class="plus"><i class="fa-regular fa-plus"></i></button>'
          );
        }

        // Attach event listeners to plus and minus buttons
        $(this)
          .off("click", ".plus")
          .on("click", ".plus", function (e) {
            e.preventDefault();

            var currentValue = parseInt(qtyInput.val());

            if (!isNaN(currentValue)) {
              qtyInput.val(currentValue + 1);
              updateActionButtonState();
            }
          });

        $(this)
          .off("click", ".minus")
          .on("click", ".minus", function (e) {
            e.preventDefault();

            var currentValue = parseInt(qtyInput.val());

            if (!isNaN(currentValue) && currentValue > 1) {
              qtyInput.val(currentValue - 1);
              updateActionButtonState();
            }
          });
      });
  }

  // Update the disabled state of the actions button based on the quantity
  function updateActionButtonState() {
    $(".actions button.button").prop("disabled", false);
  }

  // Update T&C link on checkout
    // Find the label for the checkbox
    var label = $('#terms_conditions_field label');

    // Check if the label exists
    if (label.length > 0) {

      // Get the existing label text, split to keep non-replaced parts
      var labelText = label.html().split("terms and conditions");
  
      // Define the replacement HTML for "terms and conditions"
      var replacementHtml = '<a href="/terms-and-conditions/" target="_blank" class="ms-1 btn-underline-secondary">terms and conditions</a>';
  
      // Update the label's HTML content by inserting the replacement HTML
      label.html(labelText[0] + replacementHtml + labelText[1]);
    }

  // Order Checkout Billing Form
  function orderCheckout() {
    setTimeout(function(){
      var billingFields = [
        '#billing_first_name_field',    
        '#billing_last_name_field',     
        '#billing_company_field',       
        '#billing_phone_field',         
        '#billing_email_field',         
        '#billing_vat_number_field',    
        '#billing_country_field',       
        '#billing_address_1_field',     
        '#billing_address_2_field',     
        '#billing_postcode_field',      
        '#billing_city_field',          
        '#billing_state_field',         
        '#billing_address_type_field', 
        '#billing_disclaimer_field',  
        '#billing_eori_ein_number_field',  
        '#terms_conditions_field',      
        '#kl_newsletter_checkbox_field'       
      ];
    
      // Find the parent container of the billingFields (update this selector based on your WooCommerce theme).
      var $billingFieldsContainer = $('.woocommerce-billing-fields__field-wrapper');
    
      // Loop through the billingFields array and append them to the container in the desired order.
      $.each(billingFields, function(index, field) {
        var $field = $(field);  // Get the field by the selector.
        if ($field.length) {
          $billingFieldsContainer.append($field);  // Append field to the parent container.
        }
      });
  
      var shippingFields = [
        '#shipping_first_name_field',
        '#shipping_last_name_field',
        '#shipping_company_field',
        '#shipping_phone_field',
        '#shipping_email_field',
        '#shipping_country_field',    
        '#shipping_address_1_field',     
        '#shipping_address_2_field',       
        '#shipping_postcode_field',    
        '#shipping_city_field',         
        '#shipping_state_field',         
        '#shipping_address_type_field', 
        '#shipping_eori_ein_number_field',     
        '#shipping_disclaimer_field',          
      ];
  
      // Find the parent container of the billingFields (update this selector based on your WooCommerce theme).
      var $shippingFieldsContainer = $('.woocommerce-shipping-fields__field-wrapper');
  
      // Loop through the billingFields array and append them to the container in the desired order.
      $.each(shippingFields, function(index, field) {
        var $field = $(field);  // Get the field by the selector.
        if ($field.length) {
          $shippingFieldsContainer.append($field);  // Append field to the parent container.
        }
      });
    }, 50);
  }

  $(document).ajaxComplete(function (event, xhr, settings) {
    orderCheckout();
  });

  // Array of EU countries
  var allowedCountries = [
    "Austria",
    "Belgium",
    "Bulgaria",
    "Croatia",
    "Republic of Cyprus",
    "Czech Republic",
    "Denmark",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Hungary",
    "Ireland",
    "Italy",
    "Latvia",
    "Lithuania",
    "Luxembourg",
    "Malta",
    "Netherlands",
    "Poland",
    "Portugal",
    "Romania",
    "Slovakia",
    "Slovenia",
    "Spain",
    "Sweden",
    "United States (US)",
    "United States (US) Minor Outlying Islands",
  ];

  // Validate Form
  var billingFields = [
    '#billing_first_name_field',
    '#billing_last_name_field',
    '#billing_phone_field',
    '#billing_email_field',
    '#billing_country_field',
    '#billing_address_1_field',
    '#billing_postcode_field',
    '#billing_city_field',
    '#billing_state_field',
    '#billing_disclaimer_field',
    '#billing_eori_ein_number_field',
    '#terms_conditions_field',
  ];

  var shippingFields = [
    '#shipping_first_name_field',
    '#shipping_last_name_field',
    '#shipping_country_field',    
    '#shipping_address_1_field',        
    '#shipping_city_field',         
    '#shipping_postcode_field',    
    '#shipping_eori_ein_number_field',     
    '#shipping_disclaimer_field',          
  ];

  function validateAllFields() {
    var billingEnabled = true;

    // Get the value of the #billing_address_type_field
    var billingAddressType = $('#billing_address_type_field input[name="billing_address_type"]:checked').val();

    var billingCountry = null;
    var selectedValue = null;
    if($("#select2-billing_country-container").length > 0) {
      billingCountry = $("#select2-billing_country-container").attr("title");
    } else {
      selectedValue = $('#billing_country').val();
      billingCountry = $('#billing_country option[value="' + selectedValue + '"]').text();
    }

    var shippingAddressType = $('#shipping_address_type_field input[name="shipping_address_type"]:checked').val();

    var shippingCountry = null;
    var selectedShippingValue = null;
    if($("#select2-shipping_country-container").length > 0) {
      shippingCountry = $("#select2-shipping_country-container").attr("title");
    } else {
      selectedShippingValue = $('#shipping_country').val();
      shippingCountry = $('#shipping_country option[value="' + selectedShippingValue + '"]').text();
    }

    var shippingEnabled = $('#ship-to-different-address-checkbox:checked').val();

    billingFields.forEach(function(selector) {
      // Skip #billing_state_field if the country has no states/regions defined
      // WooCommerce either hides the field wrapper or replaces the select with a hidden input
      if (selector === '#billing_state_field' && ($(selector).is(':hidden') || $(selector).find('input[type="hidden"]').length > 0)) {
        $(selector).removeClass('empty-field');
        return;
      }

      // Skip #billing_eori_ein_number_field if address type is not 'business'
      if (selector === '#billing_eori_ein_number_field' && (billingAddressType === 'residential' || allowedCountries.indexOf(billingCountry) === -1)) {
        $(selector).removeClass('empty-field');
        return;
      }

      if (selector === '#billing_disclaimer_field' && (billingCountry === 'United Kingdom (UK)' || billingCountry === 'GB')) {
        $(selector).removeClass('empty-field');
        return;
      }

      var field = $(selector).find('input, select, textarea');

      // If it's a checkbox, we need to check if it is checked
      if (field.is(':checkbox')) {
        if (!field.prop('checked')) {
          $(selector).addClass('empty-field');  // Add class if checkbox is unchecked
          billingEnabled = false;  // Set to false if checkbox is not checked
        } else {
          $(selector).removeClass('empty-field');
        }
      } else {
        // For other fields (input, select, textarea), check if they are empty
        if (field.length > 0 && field.val() === '') {
          $(selector).addClass('empty-field');
          billingEnabled = false;  // Set to false if any field is empty
        } else {
          $(selector).removeClass('empty-field');
        }
      }
    });

    if (shippingEnabled) {
      shippingFields.forEach(function(selector) {

        if (selector === '#shipping_eori_ein_number_field' && (shippingAddressType === 'residential' || allowedCountries.indexOf(shippingCountry) === -1)) {
          $(selector).removeClass('empty-field');
          return;
        }
        
        // Skip #shipping_eori_ein_number_field if address type is not 'business'
        if (selector === '#shipping_disclaimer_field' && (shippingCountry === 'United Kingdom (UK)' || shippingCountry === 'GB')) {
          $(selector).removeClass('empty-field');
          return;
        }
  
        var field = $(selector).find('input, select, textarea');
  
        // If it's a checkbox, we need to check if it is checked
        if (field.is(':checkbox')) {
          if (!field.prop('checked')) {
            $(selector).addClass('empty-field');  // Add class if checkbox is unchecked
            billingEnabled = false;  // Set to false if checkbox is not checked
          } else {
            $(selector).removeClass('empty-field');
          }
        } else {
          // For other fields (input, select, textarea), check if they are empty
          if (field.length > 0 && field.val() === '') {
            $(selector).addClass('empty-field');
            billingEnabled = false;  // Set to false if any field is empty
          } else {
            $(selector).removeClass('empty-field');
          }
        }
      });
    }

    // Enable or disable the button based on billingEnabled
    $('#place_order').prop('disabled', !billingEnabled);

    if (!billingEnabled) {
      $('.gpay-button-container').addClass('disabled');
    } else {
      $('.gpay-button-container').removeClass('disabled');
    }
  }

  // Attach event handlers
  billingFields.forEach(function(selector) {
    var field = $(selector).find('input, select, textarea');

    // Checkboxes trigger validation on change, other inputs on blur
    if (field.is(':checkbox')) {
      field.on('change', validateAllFields);
    } else {
      field.on('blur', validateAllFields);
    }
  });

  shippingFields.forEach(function(selector) {
    var field = $(selector).find('input, select, textarea');

    // Checkboxes trigger validation on change, other inputs on blur
    if (field.is(':checkbox')) {
      field.on('change', validateAllFields);
    } else {
      field.on('blur', validateAllFields);
    }
  });

  // Handle address type field change
  $('#billing_address_type_field input[name="billing_address_type"]').on('change', validateAllFields);
  $('#shipping_address_type_field input[name="shipping_address_type"]').on('change', validateAllFields);
  $('#ship-to-different-address-checkbox').on('change', validateAllFields);

  $(document).ajaxComplete(function () {
    validateAllFields();
  });

  // Displaying custom field on checkout

  // Function to check if a country is in the EU
  function isAllowedCountry() {
    // Billing Address Type
    var billingCountry = null;
    var selectedValue = null;
    if($("#select2-billing_country-container").length > 0) {
      billingCountry = $("#select2-billing_country-container").attr("title");
    } else {
      selectedValue = $('#billing_country').val();
      billingCountry = $('#billing_country option[value="' + selectedValue + '"]').text();
    }

    var billingType = $('#billing_address_type_field input[name="billing_address_type"]:checked').val();

    // Shipping Address Type
    var shippingCountry = null;
    var selectedShippingValue = null;
    if($("#select2-shipping_country-container").length > 0) {
      shippingCountry = $("#select2-shipping_country-container").attr("title");
    } else {
      selectedShippingValue = $('#shipping_country').val();
      shippingCountry = $('#shipping_country option[value="' + selectedShippingValue + '"]').text();
    }

    var shippingType = $('#shipping_address_type_field input[name="shipping_address_type"]:checked').val();

    // Adds the EORI/EIN number field to checkout for billing
    var euDisclaimer = '<p class="mb-0 mt-4">We cannot export to a business address in this country without a EORI (Economic Operators Registration and Identification). Any orders without a valid number will be rejected.</p>';
    var usDisclaimer = '<p class="mb-0 mt-4">We cannot export to a business address in this country without a EIN (Employer Identification Number / Federal Tax Identification Number) number. Any orders without a valid number will be rejected.</p>';

    // Billing Country Checks
    if (allowedCountries.indexOf(billingCountry) !== -1) {
      // Update Visibility
      $("#billing_address_type_field").removeClass("d-none");
      $("#billing_address_type_field").addClass("d-flex");

      if (billingType == 'business') {
        // Update Visibility
        $("#billing_eori_ein_number_field").addClass("d-flex");
        $("#billing_eori_ein_number_field").removeClass("d-none");

        // Check if the selected country is either "United States (US)" or "United States (US) Minor Outlying Islands"
        if ($("#billing_eori_ein_number_field").find('p').length === 0) {
          if (billingCountry === "United States (US)" || billingCountry === "United States (US) Minor Outlying Islands") {
            $("#billing_eori_ein_number_field").append(usDisclaimer);
          } else {
            $("#billing_eori_ein_number_field").append(euDisclaimer);
          }
        }
      } else {
        // Update Visibility
        $("#billing_eori_ein_number_field").addClass("d-none");
        $("#billing_eori_ein_number_field").removeClass("d-flex");
      }
    } else {
      // Remove Display
      $("#billing_eori_ein_number_field").removeClass("d-flex");
      $("#billing_address_type_field").removeClass("d-flex");

      // Add None Display
      $("#billing_eori_ein_number_field").addClass("d-none");
      $("#billing_address_type_field").addClass("d-none");

      // Remove International Number
      $("#billing_eori_ein_number").val('');
      $("#billing_eori_ein_number_field").find('p').remove();
    }

    // Billing Disclaimer
    if (billingCountry !== 'United Kingdom (UK)') {
      $("#billing_disclaimer_field").removeClass("d-none");
      $("#billing_disclaimer_field").addClass("d-flex");
    } else {
      $("#billing_disclaimer_field").removeClass("d-flex");
      $("#billing_disclaimer_field").addClass("d-none");
    }

    // Shipping Country Checks
    if ($("#ship-to-different-address-checkbox").prop("checked")) {
      if (allowedCountries.indexOf(shippingCountry) !== -1) {
        // Update Visibility
        $("#shipping_address_type_field").removeClass("d-none");
        $("#shipping_address_type_field").addClass("d-flex");
  
        if (shippingType == 'business') {
          // Update Visibility
          $("#shipping_eori_ein_number_field").addClass("d-flex");
          $("#shipping_eori_ein_number_field").removeClass("d-none");
  
          // Check if the selected country is either "United States (US)" or "United States (US) Minor Outlying Islands"
          if ($("#shipping_eori_ein_number_field").find('p').length === 0) {
            if (shippingCountry === "United States (US)" || shippingCountry === "United States (US) Minor Outlying Islands") {
              $("#shipping_eori_ein_number_field").append(usDisclaimer);
            } else {
              $("#shipping_eori_ein_number_field").append(euDisclaimer);
            }
          }
        } else {
          // Update Visibility
          $("#shipping_eori_ein_number_field").addClass("d-none");
          $("#shipping_eori_ein_number_field").removeClass("d-flex");
        }
      } else {
        // Remove Display
        $("#shipping_eori_ein_number_field").removeClass("d-flex");
        $("#shipping_address_type_field").removeClass("d-flex");
  
        // Add None Display
        $("#shipping_eori_ein_number_field").addClass("d-none");
        $("#shipping_address_type_field").addClass("d-none");
  
        // Remove International Number
        $("#shipping_eori_ein_number").val('');
        $("#shipping_eori_ein_number_field").find('p').remove();
      }

      // Shipping Disclaimer
      if (shippingCountry !== 'United Kingdom (UK)') {
        $("#shipping_disclaimer_field").removeClass("d-none");
        $("#shipping_disclaimer_field").addClass("d-flex");
      } else {
        $("#shipping_disclaimer_field").removeClass("d-flex");
        $("#shipping_disclaimer_field").addClass("d-none");
      }
    }
  }

  // function setDefaultUKState() {
  //   var countryFieldBilling = $('#billing_country');
  //   var stateFieldBilling = $('#billing_state');
  //   var countryFieldShipping = $('#shipping_country');
  //   var stateFieldShipping = $('#shipping_state');

  //   // Set default state for billing address
  //   if (countryFieldBilling.val() === 'GB') {
  //     stateFieldBilling.val('EN').change();
  //     stateFieldBilling.trigger('change');
  //   }

  //   // Set default state for shipping address if shipping address is visible
  //   if ($("#ship-to-different-address-checkbox").is(':checked')) {
  //     if (countryFieldShipping.val() === 'GB') {
  //       stateFieldShipping.val('EN').change();
  //       stateFieldShipping.trigger('change');
  //     }
  //   }
  // }

  // setDefaultUKState();

  $(document).ajaxComplete(function (event, xhr, settings) {
    setTimeout(function () {
      isAllowedCountry();
    }, 1000);
  });

  var typingTimer;
  var doneTypingInterval = 1000;

  $("#billing_eori_ein_number").on("input", function () {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(isAllowedCountry, doneTypingInterval);
  });

  $("#shipping_eori_ein_number").on("input", function () {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(isAllowedCountry, doneTypingInterval);
  });

  $("#ship-to-different-address-checkbox").change(function () {
    isAllowedCountry();
  });

  $('body').on('change', '#billing_country_field #billing_country', function(){
    $("#billing_eori_ein_number_field p").remove();
    isAllowedCountry();

    // setTimeout(function(){
    //   setDefaultUKState();
    // }, 1000);

    setTimeout(function(){
      $('body').trigger('update_checkout');
    }, 2500);
  });

  $('body').on('change', '#shipping_country_field #shipping_country', function(){
    $("#shipping_eori_ein_number_field p").remove();
    isAllowedCountry();

    // setTimeout(function(){
    //   setDefaultUKState();
    // }, 1000);

    setTimeout(function(){
      $('body').trigger('update_checkout');
    }, 2500);
  });

  $('#billing_address_type_field input[name="billing_address_type"]').change(function () {
    isAllowedCountry();
  });

  $('#shipping_address_type_field input[name="shipping_address_type"]').change(function () {
    isAllowedCountry();
  });

  $('#billing_disclaimer_field #billing_disclaimer').change(function () {
    isAllowedCountry();
  });

  $('#shipping_disclaimer_field #shipping_disclaimer').change(function () {
    isAllowedCountry();
  });

  // Product Category Tabs
    // Makes first visible on page load
    $('.taxonomy-container').hide();
    $(".taxonomy-container:first").removeAttr("style");

    // Event handler for accordion button click
    $('.taxonomy-button').on('click', function() {
      // Get the data-title from the clicked button
      var buttonTitle = $(this).data('title');

      // Hide all taxonomy containers
      $('.taxonomy-container').hide();

      console.log('data title:' + buttonTitle);

      // Show only the taxonomy containers where the data-title matches the button's data-title
      $('.taxonomy-container').each(function() {
        console.log('data target:' + $(this).data('title'));
        if ($(this).data('title') === buttonTitle) {
          $(this).show();
        }
      });
    });

  // Footer View More

  $("#brands-more").on("click", function () {
    $(".extra-columns").toggleClass("active");
    var buttonText = $(".extra-columns").hasClass("active")
      ? "View Less"
      : "View More";
    $(this).text(buttonText);
  });

  // Accordion on mobile display
  // Function to toggle visibility of hidden accordion items
  function toggleAccordionItems() {
    if ($(window).width() <= 991) {
      $("#attributeAccordion .accordion-item:not(:first-child)").hide();
    } else {
      $("#attributeAccordion .accordion-item:not(:first-child)").show();
    }
  }

  // Button click event to toggle visibility
  $("#showFilters").on("click", function (e) {
    e.preventDefault();
    $("#attributeAccordion .accordion-item:not(:first-child)").toggle();
  });

  // Form Validation

  // function handleEnterKey(event, formSelector) {
  //   // Check if the key pressed is Enter
  //   if (event.keyCode == 13) {
  //     // Prevent the default behavior of the Enter key
  //     event.preventDefault();

  //     // Get the value of the input field
  //     let input = $(this).val().trim();

  //     // Check if the input is empty
  //     if (input === "") {
  //       alert("Please fill out the text input.");
  //     } else {
  //       $(formSelector).submit();
  //     }
  //   }
  // }

  // $("#category-search .form-control").keydown(function (event) {
  //   handleEnterKey.call(this, event, "#category-search");
  // });

  // $("#global-search .form-control").keydown(function (event) {
  //   handleEnterKey.call(this, event, "#global-search");
  // });

  // Define the function
  function handleFilters() {
    $(".wcapf-form .wcapf-filter")
      .not(".wcapf-filter-keyword")
      .each(function () {
        var $filter = $(this);
        var $filterInner = $filter.find(".wcapf-filter-inner");
        var $filterOptions = $filterInner.find("ul.wcapf-filter-options");
        var $filterDropdown = $filterInner.find(".wcapf-dropdown-wrapper");

        if ($filterDropdown.length === 1) {
          $filter.removeClass("d-none");
        } else if ($filterOptions.length === 1) {
          $filter.removeClass("d-none");
        } else {
          $filter.addClass("d-none");
        }
      });
  }

  function shippingRemove() {
    // Flags for removing shipping methods
    var feeShipping = false;
    var freeShipping = true;
  
    // Iterate over each cart item to check the data-shipping value
    $('.woocommerce-checkout tr.cart_item').each(function() {
      var shippingVal = $(this).data('shipping'); // Retrieve the data-shipping value

      // If any shippingVal is not equal to 4373, set feeShipping to true
      if (shippingVal !== 4373) {
        feeShipping = true;
        freeShipping = false;
      }

      // If any shippingVal is equal to 4373, keep freeShipping true
      if (shippingVal == 4373 && freeShipping) {
        freeShipping = true;
      } else {
        freeShipping = false;
      }
    });

    // Remove the flat rate option if any product doesn't have shipping value of 4373
    if (feeShipping) {
      $('#shipping_method_0 option[value="flat_rate:31"]').remove();
    }
  
    // Remove the fee rate option if all products have shipping value of 4373
    if (freeShipping) {
      $('#shipping_method_0 option[value="table_rate:27"]').remove();
    }
  }

  // Run the function on page load
  handleFilters();
  shippingRemove();

  // Run the function when an AJAX request completes
  $(document).ajaxComplete(function () {
    handleFilters();
    shippingRemove();
  });

  // Filter Toggle
  function filterToggle() {
    if (!$('.filter-toggle').hasClass('active')) {
      $(".wcapf-form").addClass("hidden");
    }
  }

  $(".filter-toggle").on("click", function () {
    $(this).toggleClass('active');
    //alert('t');
    $(".wcapf-form").toggleClass("hidden");
    filterToggle();
  });

  // Center slider function
  function centerSlider(slideClass) {
    if ($(window).width() <= 991) {
      setTimeout(function () {
        // Get the index of the slide to be centered
        var targetIndex = $(slideClass).attr("data-focus-term");

        // Center the slide with the specified index
        $(slideClass).slick("slickGoTo", targetIndex);
      }, 1000);
    }
  }

  // Ninja forms clear input on change
  $(document).on("nfFormReady", function (e, layout) {
    // Use event delegation to attach the change event handler
    $(document).on(
      "change",
      '.answer-skip-checkbox .nf-field-element input[type="radio"]',
      function () {
        var radioValue = $(this).val();

        if (radioValue == "answer") {
          // Find the parent .nf-row of the radio input
          var parentRow = $(this).closest(".nf-row");

          // Find the next .nf-row and locate the .answer-value field within it
          var answerValueField = parentRow
            .next(".nf-row")
            .find(".answer-value");

          // Clear the text inside the .answer-value field
          answerValueField.val("");
        }
      }
    );
  });

  // Adding disclaimer text
  function disclaimerValidation () {
    let billingVal = $('#billing_country').val();
    let shippingVal = $('#shipping_country').val();
    let shippingState = false;

    // Gets the current state of the #ship-to-different-address-checkbox checkbox
    if ($("#ship-to-different-address-checkbox").prop("checked")) {
      // If checked then we want to check the shipping country
      if (shippingVal == 'GB') {
        shippingState = true;
      } else {
        shippingState = false;
      }
      // else we checked then we want to check the billing country
    } else {
      if (billingVal == 'GB') {
        shippingState = true;
      } else {
        shippingState = false;
      }
    }

    let chosenVal = '';
    if ($('input.shipping_method').length > 0) {
      chosenVal = $('input.shipping_method').val();
    } else {
      chosenVal = $('.woocommerce-shipping-totals select').val();
    }

    // Checks the state of the shipping methods
    if (chosenVal !== undefined) {
      // Sets the disclaimer for international shipping about tax rates
      if (chosenVal.includes('local_pickup') && shippingState == false) {
        if(!$('.woocommerce-checkout-review-order-table p.order-review-disclaimer').length) {
          $('.woocommerce-checkout-review-order-table').append('<p class="mb-0 mt-6 order-review-disclaimer">Please be advised that Value Added Tax (VAT) will be temporarily charged on all collection orders. However, upon export of the goods, the VAT will be refunded accordingly.</p>')
        }
      // Removes the disclaimer if shipping inside UK/GB
      } else {
        $('.woocommerce-shipping-totals p.order-review-disclaimer').remove();
      }
    }
  }

  // Multi select the select fields for change
  $('.woocommerce-shipping-totals select, #billing_country, #shipping_country, #ship-to-different-address-checkbox').on('change', function(){
    disclaimerValidation();
  });

  // Run the function for disclaimer on ajax complete
  $(document).ajaxComplete(function (event, xhr, settings) {
    setTimeout(function () {
      disclaimerValidation();
    }, 1000);
  });

  // Updating single product page button

  if ($('.single-product .call-for-price').length > 0) {
    $('.single-product .single_add_to_cart_button').addClass('d-none');
    $('.single-product .price').addClass('d-none');
    $('.single-product .quantity').addClass('d-none');
  }

  // Find the form and replace it with a div
  $('.dgwt-wcas-search-form').each(function() {
    var form = $(this);
    
    // Replace <form> with <div>
    var div = $('<div>', {
      class: form.attr('class'), // Keep the same classes as the form
      id: form.attr('id')        // Keep the same id if it exists
    });

    // Move all children (inputs, buttons, etc.) to the new <div>
    form.children().appendTo(div);
    
    // Remove the action and method attributes (if any)
    form.removeAttr('action').removeAttr('method');
    
    // Replace the form with the div in the DOM
    form.replaceWith(div);
  });

  // Listen for Enter keypress in the search input
  $('.dgwt-wcas-search-input').on('keydown', function(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault(); // Prevent the default form submission (if inside a form)

      // Get the search input value
      var searchQuery = $(this).val();

      // Store the search term in local storage
      localStorage.setItem('searchQuery', searchQuery);

      // Redirect to the shop page
      window.location.href = '/shop/';
    }
  });

  $('.dgwt-wcas-ico-magnifier').on('click', function(){
    // Get the search input value
    var searchQuery = $(this).siblings('.dgwt-wcas-search-input').val();

    // Store the search term in local storage
    localStorage.setItem('searchQuery', searchQuery);

    // Redirect to the shop page
    window.location.href = '/shop/';
  });

  // On the shop page, update the search input with the stored query
  if (window.location.pathname === '/shop/') {
    // Get the search query from local storage
    var searchQuery = localStorage.getItem('searchQuery');

    if (searchQuery) {
      // Update the search box and any related UI elements
      var searchBox = $('.wcapf-search-box input');
      $('.search-term').text(searchQuery); // Assuming .search-term is a display element
      $(searchBox).val(searchQuery).trigger('change'); // Trigger change event if needed

      // Optionally, clear the search query from local storage
      localStorage.removeItem('searchQuery');
    }
  }

  // Cookie Changes
    // Function to get cookie value by name
    function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
      const parts = cookies[i].split('=');
      if (parts[0] === name) {
        return parts[1];
      }
    }
    return null;
  }

  setTimeout(function() {
    // Check if the cookie is set to 'enabled_cookie'
    const cookieValue = getCookie('product_resources_cookie');
    if (cookieValue === 'enabled_cookie') {
      $('.resourcesForm').each(function () {
        $(this).find('.submit-wrap .submit-field').text('Download').trigger('change');
      });
    }
  },500);

  // Use event delegation to bind the click handler
  $(document).on('click', '.page-numbers', function() {
    $('html, body').animate({ scrollTop: 0 }, 300);
  });

  $.fn.isScrolledIntoView = function () {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(this).offset().top;
    return elemTop <= docViewBottom && elemTop >= docViewTop;
  };
});

/**
 * @description loads the AOS library after a set timeout
 */
let loadAOS = () => {
  setTimeout(() => {
    $("body").addClass("loaded");
    setTimeout(() => {
      AOS.init();
    }, 500);
  }, 1000);
};

/**
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
 */
let checkWindowScroll = () => {
  let scroll = $(window).scrollTop();
  if (scroll > 0) {
    $("header").addClass("scroll");
    submenuOffset();
  } else {
    $("header").removeClass("scroll");

    if ($("#desktopNav").hasClass("active")) {
      $("#desktopNav").removeClass("active");
    }

    if ($("#burger").hasClass("open")) {
      $("#burger").toggleClass("open");
      $("#burger").click();
    }

    setTimeout(function () {
      submenuOffset();
    }, 500);
  }
};

/**
 * @description function for fixing floating elements or page width elements with content to the conventional bootstrap container sizes
 */
let containerFix = () => {
  if ($(".container-fix").length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1440,
    };
    let windowWidth = $(window).width();
    let containerWidth = 0;
    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    var padding = (windowWidth - containerWidth) / 2 + 32;

    if (windowWidth >= 992) {
      $(".container-fix").each(function () {
        if ($(this).hasClass("odd")) {
          $(this).css("padding-left", "0px");
          $(this).css("padding-right", padding + "px");
        } else if ($(this).hasClass("even")) {
          $(this).css("padding-left", padding + "px");
          $(this).css("padding-right", "0px");
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $(".container-fix").each(function () {
        $(this).css("padding-left", padding + "px");
        $(this).css("padding-right", padding + "px");
      });
    } else {
      $(".container-fix").each(function () {
        $(this).css("padding-left", "32px");
        $(this).css("padding-right", "32px");
      });
    }
  }
};
/**
 *  @description affix appropriately css positioned elements (ie position = fixed || absolute) below the header banner
 */
let submenuOffset = () => {
  let scroll = $(document).scrollTop();
  let topstripHeight = 0;
  let desktopNavHeight = $("#desktopNav").outerHeight();
  let dropdown = $(".submenu.simple");
  let megamenu = $(".submenu.mega");
  let headerHeight;

  if ($("body").hasClass("logged-in") && $("body").hasClass("admin-bar")) {
    headerHeight = $("#header").outerHeight() + 32;
  } else {
    headerHeight = $("#header").outerHeight();
  }

  if (scroll == 0) {
    dropdown.css("top", desktopNavHeight + "px");
    megamenu.css("top", headerHeight + "px");
  } else if (scroll < topstripHeight) {
    dropdown.css("top", scroll + desktopNavHeight + "px");
    megamenu.css("top", scroll + headerHeight + "px");
  } else {
    dropdown.css("top", desktopNavHeight + "px");
    megamenu.css("top", headerHeight + "px");
  }
};

/**
 * @description offset elements labeled with the offset hero class by the height of the header
 */
let heroOffset = () => {
  let hero = $(".offset-hero");
  let header = $("header");

  if (hero.length && header.length) {
    let height = $(header).outerHeight();
    $(hero).css("margin-top", `${height}px`);
  }
};

/**
 * @description reveals hidden page elements
 */
let uncoverElements = () => {
  $(".uncover").each(function () {
    if ($(this).isScrolledIntoView() === true) {
      $(this).addClass("show");
    }
  });
};

/**
 * @description loads timages via the server over local files
 */
let imageReplace = () => {
  return;
  
  var host = window.location.hostname;

  // Check if the current host matches the expected host
  if (host === 'tfpumps.test' || host === 'localhost:3000' || host === 'localhost') {
    host = 'tfpumps.com';
  }

  // Replace domain in <img> src attributes
  $('img').each(function () {
    const currentSrc = $(this).attr('src');

    // Update test domain
    if (currentSrc && currentSrc.includes('tfpumps.test')) {
      $(this).attr('src', currentSrc.replace('tfpumps.test', host));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', host));
    }
  });

  // Replace domain in <video> src attributes
  $('video').each(function () {
    const currentSrc = $(this).attr('src');
    const currentPoster = $(this).attr('poster');

    // Update test domain
    if (currentSrc && currentSrc.includes('tfpumps.test')) {
      $(this).attr('src', currentSrc.replace('tfpumps.test', host));
    }

    if (currentPoster && currentPoster.includes('tfpumps.test')) {
      $(this).attr('poster', currentPoster.replace('tfpumps.test', host));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', host));
    }

    if (currentPoster && currentPoster.includes('localhost:3000')) {
      $(this).attr('poster', currentPoster.replace('localhost:3000', host));
    }
  });

  // Replace domain in <div> background-image style attributes
  $('div').each(function () {
    const currentBg = $(this).css('background-image');

    // Update test domain
    if (currentBg && currentBg.includes('tfpumps.test')) {
      const updatedBg = currentBg.replace('tfpumps.test', host);
      $(this).css('background-image', updatedBg);
    }

    // Update local domain
    if (currentBg && currentBg.includes('localhost:3000')) {
      const updatedBg = currentBg.replace('localhost:3000', host);
      $(this).css('background-image', updatedBg);
    }
  });
};

/**
 * @description initialise the slick sliders for the page
 */
let initSliders = () => {
  // generic slider example
  // go to - https://kenwheeler.github.io/slick/ - for documentation
  $(".slider").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".date-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"></button>',
    prevArrow: '<button class="slick-arrow slick-prev"></button>',
    slidesToScroll: 1,
    variableWidth: true,
    infinite: false,
  });

  $(".brands-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"></button>',
    prevArrow: '<button class="slick-arrow slick-prev"></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
          centerMode: true,
        },
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 7,
        },
      },
    ],
  });

  $(".product-cat-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"></button>',
    prevArrow: '<button class="slick-arrow slick-prev"></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    mobileFirst: true,
    centerMode: true,
    centerPadding: "30px",
    responsive: [
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 5,
        },
      },
    ],
  });

  // slider arrow functionality
  // $('.slick-{arrow-name}.slick-prev').click(function () {
  //   $('.{carousel-name}').slick('slickPrev');
  // });
  // $('.slick-{arrow-name}.slick-next').click(function () {
  //   $('.{carousel-name}').slick('slickNext');
  // });
};

/**
 * @description handles opening and closing of the mobile menu on the site
 *
 * @param {*} open flag indicating whether or not the menu is in an open state
 */
var open = false;
let toggleMenu = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile ul").toggleClass("open", open);
  $("#desktopNav").toggleClass("active", open);
};

/**
 * @description centers the map on the current marker or in the center of all markers present
 *
 * @param {*} map the JSON map object being worked on
 */
let centerMap = (map) => {
  let bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function (i, marker) {
    let latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );
    bounds.extend(latlng);
  });
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(map.zoom);
  } else {
    map.fitBounds(bounds);
  }
};

/**
 * @description adds a new marker to the map being created
 *
 * @param {*} $marker the jQuery HTML marker to be added
 * @param {*} map the JSON map object to be operated on
 */
let addMarker = ($marker, map) => {
  let latlng = new google.maps.LatLng(
    $marker.attr("data-lat"),
    $marker.attr("data-lng")
  );
  let icon = {
    url: "" + $marker.attr("data-icon") + "",
    scaledSize: new google.maps.Size(48, 48),
  };
  let marker = new google.maps.Marker({
    icon: icon,
    map: map,
    position: latlng,
  });
  map.markers.push(marker);
  if ($marker.html()) {
    let infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });
    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  }
};

/**
 * @description creates a new map at the location of the jQuery element passed in
 *
 * @param {*} $el the jQuery element to create a map aroudn
 */
let newMap = ($el) => {
  let $markers = $el.find(".marker");
  let args = {
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    zoom: 12,
  };
  let map = new google.maps.Map($el[0], args);
  map.markers = [];
  $markers.each(function () {
    addMarker($(this), map);
  });
  centerMap(map);
  return map;
};

/**
 * @description convenience function for running all code required to generate a single (or multiple) maps on a page
 */
let initGoogleMapping = () => {
  $(".map").each(function () {
    newMap($(this));
  });
};